import React, { useEffect, useState } from 'react';
import style from './css/hero.module.css';

import img1 from '../../assets/tech-guy.jpg'
import img2 from '../../assets/tech-girl.jpg'
import img3 from '../../assets/ai.jpg'

const images = [
  {
    url: img1,
    caption: 'Tech is the new oil — start drilling.',
  },
  {
    url: img2,
    caption: 'Learn tech, earn big.',
  },
  {
    url: img3,
    caption: 'From keyboard to paycheck.',
  },
];

export default function Hero({ onGetStartedClick }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={style.hero}
      style={{
        backgroundImage: `linear-gradient(to right, rgba(238, 166, 0, 0.6), rgba(231, 27, 0, 0.2)), url(${images[index].url})`,
      }}
    >
      <div className={style.content}>
        <h1>{images[index].caption}</h1>
        <p>We have all the guide you need to get started here</p>
        <button className={style.getStartedBtn} onClick={onGetStartedClick}>Get started</button>
      </div>
    </div>
  );
}